import React from "react";
import styled from "styled-components";
import defaultProfileImage from "../../assets/images/profile/default.webp"; // Default profile image

const AvatarWrapper = styled.div`
  display: inline-block;
  border-radius: 50%;
  border: 2px solid ${(props) => props.$bgColor || "#ccc"}; /* Default border */
  overflow: hidden;
  width: ${(props) => props.size}px;
  height: ${(props) => props.size}px;
  line-height: ${(props) => props.size}px;
  text-align: center;
  font-weight: bold;
  font-size: ${(props) => props.size / 2}px; /* Adjust font size dynamically */
  background-color: ${(props) =>
    props.$bgColor || "#ccc"}; /* Default background */
  color: ${(props) => props.$textColor || "#fff"}; /* Default text color */
`;

const AvatarImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50%;
`;

const Avatar = ({
  name,
  profilePictureUrl,
  size = 40,
  bgColor,
  textColor,
  useDefault = false,
}) => {
  // If a profile picture URL exists, render the image
  if (profilePictureUrl) {
    return (
      <AvatarWrapper size={size} $bgColor={bgColor} $textColor={textColor}>
        <AvatarImage src={profilePictureUrl} alt={name || "User Avatar"} />
      </AvatarWrapper>
    );
  }

  if (useDefault) {
    return (
      <AvatarWrapper size={size} $bgColor={bgColor} $textColor={textColor}>
        <AvatarImage src={defaultProfileImage} alt={name || "Default Avatar"} />
      </AvatarWrapper>
    );
  }

  // Otherwise, render the fallback with the first letter
  const userName = name?.trim() || "?";
  const initial = userName[0].toUpperCase();

  return (
    <AvatarWrapper size={size} $bgColor={bgColor} $textColor={textColor}>
      {initial}
    </AvatarWrapper>
  );
};

export default Avatar;
